import { render, staticRenderFns } from "./club-admins.vue?vue&type=template&id=0d3a8b3d&scoped=true&"
import script from "./club-admins.vue?vue&type=script&lang=js&"
export * from "./club-admins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3a8b3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Vuejs-Project\\subsappadminOrg\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d3a8b3d')) {
      api.createRecord('0d3a8b3d', component.options)
    } else {
      api.reload('0d3a8b3d', component.options)
    }
    module.hot.accept("./club-admins.vue?vue&type=template&id=0d3a8b3d&scoped=true&", function () {
      api.rerender('0d3a8b3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/club-admins/club-admins.vue"
export default component.exports